
import { useEffect, useRef, useState } from 'react';
import Logo from "../../assets/images/login-logo.svg";
// import Loginbg from "../../assets/images/login-bg.webp";
import Loginbg from "../../assets/images/login-admin.png";
import { useLocation, useNavigate } from "react-router-dom";
import "./login.scss";
import WebService from '../../Services/WebService';
import { toast } from 'react-toastify';

const VerifyOTP = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [referenceNumber, setReferenceNumber] = useState(location.state?.referenceNumber || "");

    // Getting email + referenceNumber from previous page
    const email = location.state?.email || "admin@safer.com";
    const referenceNumberFromState = location.state?.referenceNumber || "";

    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const inputRefs = useRef<any>([]);

    const [loading, setLoading] = useState(false);
    const [timer, setTimer] = useState(30);
    const [errors, setErrors] = useState("");

    useEffect(() => {
        if (timer === 0) return;
        const interval = setInterval(() => setTimer((t) => t - 1), 1000);
        return () => clearInterval(interval);
    }, [timer]);

    const handleOtpChange = (value: string, index: number) => {
        if (/^\d?$/.test(value)) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

            // Move to next input
            if (value && index < 5) {
                inputRefs.current[index + 1].focus();
            }

            // Move back on delete
            if (!value && index > 0) {
                inputRefs.current[index - 1].focus();
            }
        }
    };

    const validateOtp = () => {
        const otpValue = otp.join("");
        if (otpValue.length !== 6) {
            setErrors("Please enter 6-digit OTP");
            return false;
        }
        return true;
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        if (!validateOtp()) return;

        setLoading(true);
        try {
            const res: any = await WebService.beforeLoginAPI({
                action: "admin-auth/forgot-password/verify-otp",
                body: {
                    email,
                    reference_number: referenceNumber,
                    otp: otp.join("")
                },
                isShowError: false,
            });

            toast.success(res?.message || "OTP Verified Successfully!");

            navigate("/create-password", {
                state: {
                    email,
                    referenceNumber,
                },
            });

        } catch (error: any) {
            toast.error(error?.response?.data?.message || "Invalid OTP");
        } finally {
            setLoading(false);
        }
    };

    const resendOtp = async () => {
        if (timer !== 0) return;
        setTimer(30);

        try {
            const res: any = await WebService.postAPI({
                action: "admin-auth/forgot-password/resend-otp",
                body: { email },
                isShowError: false
            });
            if (res?.status) {
                const referenceNumber = res?.reference_number;
                setReferenceNumber(referenceNumber);
                toast.success(res?.message || "New OTP sent!");
            }
        } catch (error: any) {
            toast.error(error?.response?.data?.message || "Failed to resend OTP");
        }
    };

    const handleLogin = () => {
        navigate("/create-password"); // redirect
    };
    const numbers = [3, 5, 8, 1, 4, 1];

    return (
        <div className="min-h-screen flex login-page">
            {/* Left side - Image */}
            <div className="w-3/4 hidden md:block">
                <img
                    src={Loginbg}
                    alt="Login side"
                    className="w-full h-full object-cover"
                />
            </div>

            {/* Right side - Form */}
            <div className="w-full md:w-1/2 flex flex-col justify-center items-center p-8 bg-white">
                {/* Logo */}
                <div className="mb-6 flex flex-col items-center">
                    <div className='pb-8'>
                        <img src={Logo} alt="Logo" className="" width={277} height={240} />
                    </div>
                    <h1>Verify OTP</h1>
                    <p className="text-gray-500">
                        Enter the OTP which was sent to your registered<br />email address to recover your password.
                    </p>
                </div>

                {/* Form */}
                <form className="w-full max-w-sm" onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="block mb-2">
                            Enter OTP
                        </label>
                        {/* <div className="flex gap-4">
                            {numbers.map((num, i) => (
                                <div
                                    key={i}
                                    className="w-12 h-12 flex items-center justify-center bg-gray-100 border border-gray-300 rounded-lg text-lg font-medium"
                                >
                                    {num}
                                </div>
                            ))}
                        </div> */}
                        <div className="flex gap-4 mt-3">
                            {otp.map((digit, i) => (
                                <input
                                    key={i}
                                    type="text"
                                    maxLength={1}
                                    value={digit}
                                    ref={(el) => {
                                        inputRefs.current[i] = el;
                                    }}
                                    className="
                                    otp-input
                                    w-12 h-12
                                    flex items-center justify-center
                                    text-xl font-bold text-gray-900
                                    bg-gray-100
                                    border border-gray-300 rounded-lg
                                    focus:outline-none focus:ring-2 focus:ring-blue-400
      "
                                    onChange={(e) => handleOtpChange(e.target.value, i)}
                                />
                            ))}
                        </div>

                        {errors && <p className="text-red-500 text-sm mt-2">{errors}</p>}
                    </div>
                    <button
                        type="submit"
                        disabled={loading}
                        className="mt-2 w-full bg-blue-400 hover:bg-blue-500 text-white font-medium py-2 rounded-lg"
                    >
                        {loading ? "Verifying..." : "Verify OTP"}
                    </button>
                </form>
                <div className="mt-4 mb-2 text-center text-sm font-normal text-gray-500" style={{ color: '#3C3C3C' }}>
                    Didn't receive the code?
                </div>
                <div className="flex flex-col items-center gap-2 w-full max-w-sm">
                    <button
                        onClick={resendOtp}
                        disabled={timer > 0}
                        className="text-blue-500 w-full hover:underline disabled:text-black-400 cursor-pointer bg-transparent font-medium py-2 rounded-lg"
                        style={{ color:'#FFF' }}
                    >
                        {timer > 0 ? `Resend in ${timer}s` : "Resend OTP"}
                    </button>

                    <button
                        type="button"
                        onClick={() => navigate("/login")}
                        className="mt-3 w-full text-sm text-blue-500 hover:text-blue-600 underline cursor-pointer bg-transparent font-medium py-2 rounded-lg"
                        style={{ color:'#FFF' }}
                    >
                        Back to Login
                    </button>
                </div>
            </div>
        </div>
    )

}
export default VerifyOTP;